import { render, staticRenderFns } from "./TotalesPorPrograma.vue?vue&type=template&id=f7f197ea"
import script from "./TotalesPorPrograma.vue?vue&type=script&lang=js"
export * from "./TotalesPorPrograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports